import { Component } from 'react'
import './IpPatientDetails.css'
import { withTranslation } from 'react-i18next'
import {
  Box, Accordion, AccordionSummary, AccordionDetails, Typography,
  Button, FormControl, InputLabel, Select, MenuItem, TextField,
  Stack, Autocomplete, InputAdornment
} from '@mui/material'
import { CommonPatientCard, CommonPatientDetails, ConsultantPatientCard }
  from '../../../../Components/Common Components/CommonComponents'
import ToastMsg from '../../../../Components/ToastMsg/ToastMsg'
import { getCachevalue, localGetItem } from '../../../../Utility/Services/CacheProviderService';
import { Colors } from '../../../../Styles/Colors'
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import RestAPIService from '../../../../Utility/Services/RestAPIService'
import { Serviceurls } from '../../../../Utility/API/Serviceurls'
import { LocalizationProvider, DateTimePicker } from '@mui/x-date-pickers'
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { DateTime } from 'luxon';
import Loader from '../../../../Components/Loader';
import { CheckAccessFunc } from '../../../../Components/CommonFunctions/CommonFunctions'
import VoiceToText from '../../../../Components/Common Components/VoiceToText';
import MicIcon from '@mui/icons-material/Mic';
import { grey } from '@mui/material/colors';

var add_Notes = {
  spl_id: null,
  specTxt: '',
  layout_id: '',
  template_id: '',
  template_data: {},
  date_time: null,
  name_of_doctor: '',
  signature: '',
  is_finished: null,
}

class TherapyNotes extends Component {
  constructor(props) {
    super(props)
    this.state = {
      ipPatientData: {},
      isErrorMsg: false,
      isErrorMsgText: '',
      successMsg: false,
      successMsgText: '',
      surgeryLayout: [],
      surgeryTemplate: [],
      getSNData: [],
      isFinish: false,
      addSurNotes: [add_Notes],
      expanded: false,
      isLoader: false,
      withOutAppointment: {},
      splItem: [],
      surlayout: [],
      attenderName: '',
      attenderMobile: '',
      consultantName: null,
      ClinicID: "",
      OTDetails: [],
      FromOT: false,
      listenPopUp: false,
    }
  }
  componentDidMount() {
    let IpPatientDetails = getCachevalue('IppatientData')
    let patientData = JSON.parse(IpPatientDetails)
    let appointmentDetail = getCachevalue("withoutAppointment");
    let details = JSON.parse(appointmentDetail);
    let patientDatas = getCachevalue("OTpatientData");
    let patients = JSON.parse(patientDatas);
    this.setState({
      OTDetails: patients
    })
    this.getSpeciality()
    let myUser = JSON.parse(localGetItem("loggedInUserInfo"));
    if (myUser?.module_name === "ot_management") {
      if (myUser?.clinic_id) {
        this.setState({
          ClinicID: myUser?.clinic_id,
          FromOT: true
        })
      }
    }
    var selectedClinic = JSON.parse(localGetItem("SelectedDoctorClinicId"))
    if (selectedClinic) {
      this.setState({
        ClinicID: selectedClinic,
        FromOT: (myUser?.module_name === "Doctor" || myUser?.module_name === 'JMO') ? false : true
      })
    }
    if (details?.patient_id === patientData?.patient_id) {
      this.setState({
        withOutAppointment: details
      }, () => {
        this.getSurgeyNotes()
        this.getSurgeryLayout()

      })
    }
    this.setState({
      ipPatientData: patientData
    }, () => {
      this.getSurgeyNotes()
      this.getSurgeryLayout()

    })
  }

  getSpeciality = () => {
    try {
      RestAPIService.getAll(Serviceurls.FO_CONFIG_OPSPECIALIZATION)
        .then((response => {
          if (response.data.status === 'success') {
            this.setState({
              splItem: response.data.data ? response.data.data : [],
            })
          }
        })).catch(e => {
          this.errorMessage(e?.response?.data?.message || e.message)
        })
    } catch (e) {
      this.errorMessage(e.message)
    }
  }

  errorMessage = (message) => {
    this.setState({
      isErrorMsg: true,
      isErrorMsgText: message ? message : '-',
      isSave: false
    })
  }
  successMessage = (message) => {
    this.setState({
      successMsg: true,
      successMsgText: message ? message : '-'
    })
  }

  lodaerFunction = (key) => {
    this.setState({
      isLoader: key
    })
  }
  getSurgeryLayout = (val, i) => {
    try {
      RestAPIService.getAll(Serviceurls.SUR_NOTES_LAYOUT + '?clinic_id=' + this.state.ClinicID + '&ip_admission_id=' + (this.state.ipPatientData?.id ? this.state.ipPatientData?.id : (this.state.OTDetails?.ip_admission ? this.state.OTDetails?.ip_admission : null)))
        .then(response => {
          if (response.data.status === 'success') {
            this.setState({
              surgeryLayout: response?.data?.data,
              surlayout: response?.data?.data
            }, () => {
              if (val) {
                var filterLayout = response?.data?.data ? response?.data?.data.filter((item) => item?.speciality_name === this.state.addSurNotes[i]?.spl_id?.name) : null
                this.setState({
                  surgeryLayout: filterLayout
                })
              }
            })
          }
        }).catch(e => {
          this.errorMessage(e?.response?.data?.message || e.message)
        })
    } catch (e) {
      this.errorMessage(e.message)
    }
  }
  getSurgeryTemplate = (index) => {
    try {
      var states = this.state
      var layID = states.addSurNotes?.map((item) => (item.layout_id))
      var ID = states.addSurNotes[index].layout_id ? states?.addSurNotes[index]?.layout_id : layID ? layID : ''
      if (states.addSurNotes[index]?.layout_id) {
        RestAPIService.getAll(Serviceurls.IP_SUR_NOTE_TEM + '?id=' + ID + '&clinic_id=' + this.state.ClinicID + '&ip_admission_id=' + (this.state.ipPatientData?.id ? this.state.ipPatientData?.id : (this.state.OTDetails?.ip_admission ? this.state.OTDetails?.ip_admission : null)))
          .then(response => {
            if (response.data.status === 'success') {
              this.setState({
                surgeryTemplate: response?.data?.data
              })
            }
          }).catch(e => {
            this.errorMessage(e?.response?.data?.message || e.message)
          })
      }
    } catch (e) {
      this.errorMessage(e.message)
    }
  }

  postSurgeryNotesTemplate = (index) => {
    try {
      var states = this.state
      var SNdateTime = new Date(states.addSurNotes[index].date_time)
      var AptDate = DateTime.fromJSDate(SNdateTime).toFormat('yyyy-MM-dd')
      var Aptime = DateTime.fromJSDate(SNdateTime).toLocaleString(DateTime.TIME_24_WITH_SECONDS);
      var dateTime = states.addSurNotes[index].date_time ? `${AptDate} ${Aptime}` : null
      let patient_id = states.ipPatientData?.patient_id || this.state.OTDetails?.patient_id
      let admission_id = this.state.ipPatientData?.id || this.state.OTDetails?.ip_admission;
      var add_Notes = {
        spl_id: null,
        specTxt: '',
        layout_id: '',
        template_id: '',
        template_data: {},
        date_time: null,
        name_of_doctor: '',
        signature: '',
        is_finished: false
      }
      var data = {
        "patient_id": patient_id ? patient_id : null,
        "ip_admission_id": admission_id ? admission_id : null,
        "clinic_id": this.state.ClinicID ? this.state.ClinicID : null,
        "speciality_name": states.addSurNotes[index]?.spl_id?.name ? states.addSurNotes[index]?.spl_id?.name : '',
        "layout_id": states.addSurNotes[index]?.layout_id ? states.addSurNotes[index]?.layout_id : null,
        "template_id": states.addSurNotes[index]?.template_id ? states.addSurNotes[index]?.template_id : null,
        "template_data": states.addSurNotes[index]?.template_data ? states.addSurNotes[index]?.template_data : {},
        "date_time": dateTime,
        "name_of_doctor": states.addSurNotes[index]?.name_of_doctor ? states.addSurNotes[index]?.name_of_doctor : '',
        "signature": states.addSurNotes[index]?.signature ? states.addSurNotes[index]?.signature : '',
        "is_finished": states.addSurNotes[index]?.is_finished
      }
      if (states.addSurNotes[index].id) {
        data['surgery_note_id'] = states.addSurNotes[index]?.id
      }
      this.lodaerFunction(true)
      RestAPIService.create(data, Serviceurls.IP_SN_CREATE)
        .then(response => {
          if (response.data.status === 'success') {
            this.successMessage(response?.data?.message)
            this.getSurgeyNotes()
            this.setState({
              addSurNotes: [add_Notes],
              isSave: false,
            }, () => this.lodaerFunction(false))
          }
        }).catch(e => {
          this.setState({ isSave: false })
          this.errorMessage(e?.response?.data?.message || e.message)
          this.lodaerFunction(false)
        })
    } catch (e) {
      this.setState({ isSave: false })
      this.errorMessage(e.message)
      this.lodaerFunction(false)
    }
  }

  printSurNotes(surId) {
    try {
      var states = this.state
      let PatientDetails = getCachevalue("withoutAppointment")
      let patientAdmission = PatientDetails ? JSON.parse(PatientDetails)?.ip_admission_id : null
      var patientID = states.ipPatientData?.patient_id ? states.ipPatientData?.patient_id : null
      var admissionID = this.state.OTDetails?.ip_admission || states?.ipPatientData?.id || patientAdmission
      RestAPIService.PrintPDF(Serviceurls.SUR_NOTE_PRINT + "?ip_admission_id=" + (admissionID ? admissionID : null) + "&surgery_notes_id=" + surId + '&clinic_id=' + this.state.ClinicID)
        .then((response) => {
          if (response) {
            //Create a Blob from the PDF Stream
            const file = new Blob(
              [response.data],
              { type: 'application/pdf' });
            //Build a URL from the file
            const fileURL = URL.createObjectURL(file);
            //Open the URL on new Window
            window.open(fileURL);
            this.setState({ isPrint: false })
          }
        }).catch((e) => {
          this.setState({ isPrint: false })
          this.errorMessage(e.response?.data?.message || e.message)
        })
    } catch (e) {
      this.setState({ isPrint: false })
      this.errorMessage(e.message)
    }
  }

  getSurgeyNotes = (i) => {
    try {
      var states = this.state
      let admission_id = this.state.ipPatientData?.id || this.props?.ip_admission_id || this.state.withOutAppointment?.ip_admission_id || this.state.OTDetails?.ip_admission;
      let patient_id = states.ipPatientData?.patient_id || this.state.OTDetails?.patient_id;
      var add_Notes = {
        spl_id: null,
        specTxt: '',
        layout_id: '',
        template_id: '',
        template_data: {},
        date_time: null,
        name_of_doctor: '',
        signature: '',
        is_finished: null,
      }
      this.lodaerFunction(true)
      RestAPIService.getAll(Serviceurls.IP_SN_CREATE + '?ip_admission_id=' + admission_id + '&patient_id=' + patient_id + '&clinic_id=' + this.state.ClinicID)
        .then(response => {
          if (response.data.status === 'success') {
            this.setState({
              attenderName: response?.data?.header_data ? response.data.header_data.attender_name : '',
              attenderMobile: response?.data?.header_data ? response.data.header_data.attender_mobile : '',
              consultantName: response?.data?.header_data ? response.data.header_data.doctor_name : '',
            })
            var item = response?.data?.data
            if (item?.data?.length > 0) {
              this.setState({
                getSNData: response.data.data ? response.data.data : [],
              })
              this.getSavedData(response?.data?.data ? response?.data?.data : [], i)
            } else {
              this.setState({
                addSurNotes: [add_Notes],
              })
            }
            this.lodaerFunction(false)
          }
        }).catch(e => {
          this.errorMessage(e.response?.data?.message || e.message)
          this.lodaerFunction(false)
        })
    } catch (e) {
      this.errorMessage(e.message)
      this.lodaerFunction(false)
    }
  }
  getSavedData = (data, index) => {
    if (data?.data?.length > 0) {
      var states = this.state
      var surgery = []
      surgery = data.data?.map((item) => {
        let selectedSpl = null
        selectedSpl = states.splItem?.find((list) => list?.name === item?.speciality_name)
        item["spl_id"] = selectedSpl ? selectedSpl : null
        return item
      })
      this.setState({
        addSurNotes: surgery
      }, () => {
        var SNNotes = states.addSurNotes.map((item) => (item))
        var data = states.surgeryLayout.filter((item) => (item.id == SNNotes?.layout_id))
        var keys = {}
        data[0]?.surgery_json?.forEach((element) => {
          if (surgery[index]?.template_data) {
            keys[element.field_name] = surgery[index]?.template_data[element?.field_name]
          }
        })
        SNNotes.template_data = keys
        this.setState({
          SNNotes,
        })
      })
      if (index >= 0 && index != null) {
        this.getSurgeryTemplate(index)
      }
    }
  }

  handleAcc = (i, id) => {
    var states = this.state
    return (event, isExpanded) => {
      this.setState({ expanded: isExpanded ? i : false, surgeryLayout: this.state.surlayout }, () => {
        if (states.addSurNotes[i].layout_id && id && isExpanded) {
          this.getSurgeyNotes(i)
        }
      });
    };
  }

  renderAccordionView = () => {
    const { t, fromBillSummary } = this.props
    var states = this.state
    var { addSurNotes, expanded } = this.state
    var New = states.addSurNotes.length - 1
    return (
      <Box component={'div'} className={fromBillSummary ? 'eMed_SN_IpCon' : 'eMed_SN_Con'} emed_tid="surgery_notes_accordion_container">
        {addSurNotes.length > 0 ? addSurNotes.map((list, index) => {
          var lName = states.surlayout.filter((item) => (item.id === states.addSurNotes[index]?.layout_id))
          var tName = states.surgeryTemplate.filter((item) => (item.id === states.addSurNotes[index]?.template_id))
          let filterLayout = states.surlayout?.filter((item) => (item?.speciality_name === list?.spl_id?.name))
          let layoutOption = (filterLayout && list?.spl_id?.name) ? filterLayout : this.state.surgeryLayout
          return (
            <Accordion expanded={expanded === index} onChange={this.handleAcc(index, list.id)} key={index} emed_tid={`surgery_notes_accordion_${index}`}>
              <AccordionSummary
                expandIcon={<ExpandMoreIcon emed_tid={`surgery_notes_accordion_expand_icon_${index}`} />}
                sx={{ backgroundColor: Colors.DataTblHeaderbg }}
                className='eMed_SN_Acc_Header'
                emed_tid={`surgery_notes_accordion_summary_${index}`}>
                <Box component={'div'} className='eMed_SN_Acc_HeadText' emed_tid={`surgery_notes_accordion_header_text_${index}`}>
                  <Typography emed_tid={`surgery_notes_accordion_title_${index}`}>{`TherapyNotes ${'(' + (lName[0]?.layout_name && tName[0]?.template_name ? lName[0]?.layout_name + '-' + tName[0]?.template_name : lName[0]?.layout_name ? lName[0]?.layout_name : '-') + ')'}`}</Typography>
                </Box>
              </AccordionSummary>
              <AccordionDetails sx={{ height: '61vh', overflow: 'auto' }} emed_tid={`surgery_notes_accordion_details_${index}`}>
                <Box component={'div'} className={`${fromBillSummary ? "eMed_SN_Acc_billHeadLay" : ""} eMed_SN_Acc_HeadLay`} emed_tid={`surgery_notes_accordion_header_layout_${index}`}>
                  <Box sx={{ display: 'flex', flexDirection: 'row', justifyContent: 'space-between', width: '42vw' }} emed_tid={`surgery_notes_accordion_selects_${index}`}>
                    <Autocomplete
                      noOptionsText={states.addSurNotes[index].spl_id === '' ? t('PLS') : t('NDF')}
                      options={states.splItem}
                      getOptionLabel={(options) => typeof (options) === 'string' ? options : options?.name}
                      sx={{ backgroundColor: Colors.ThemeLightColor }}
                      disabled={states.addSurNotes[index].is_finished}
                      onChange={(e, value) => {
                        var { addSurNotes } = this.state
                        addSurNotes[index]['spl_id'] = value
                        addSurNotes[index]['layout_id'] = ''
                        addSurNotes[index]['template_id'] = ""
                        this.setState({
                          addSurNotes,
                        }, () => {
                          if (value != null && expanded === index) {
                            this.getSurgeryLayout(value, index)
                          } else {
                            this.getSurgeryLayout()
                          }
                        })
                      }}
                      value={states.addSurNotes[index].spl_id}
                      size='small'
                      className='eMed_refdoc_txtbox'
                      disablePortal
                      id="Spec"
                      emed_tid={`surgery_notes_speciality_autocomplete_${index}`}
                      renderInput={(params) => <TextField onChange={(event) => {
                        const value = event.target.value
                        if (value === "" || value != "") {
                          var { addSurNotes } = this.state
                          addSurNotes[index]['specTxt'] = value
                          this.setState({ addSurNotes })
                        }
                      }} {...params} label={t('selectSpecial')} emed_tid={`surgery_notes_speciality_input_${index}`} />}
                    />
                    <FormControl size='small' className='eMed_IP_Discharge_Select' emed_tid={`surgery_notes_layout_form_${index}`}>
                      <InputLabel id="demo-simple-select-label" emed_tid={`surgery_notes_layout_label_${index}`}>{`${t('SelectLayout')} ${'(' + (layoutOption?.length > 0 ? layoutOption.length : 0) + ')'}`}</InputLabel>
                      <Select
                        labelId="demo-simple-select-label"
                        id="demo-simple-select"
                        value={addSurNotes[index].layout_id}
                        readOnly={states.addSurNotes[index].is_finished === true || fromBillSummary ? true : false}
                        sx={{ backgroundColor: Colors.ThemeLightColor }}
                        label={`${t('SelectLayout')} ${'(' + (layoutOption?.length > 0 ? layoutOption.length : 0) + ')'}`}
                        onChange={(event) => { this.handleLayout(event, index) }}
                        emed_tid={`surgery_notes_layout_select_${index}`}
                      >
                        {layoutOption?.length > 0 ? layoutOption?.map((item, itemIndex) => (
                          <MenuItem value={item.id} key={itemIndex} emed_tid={`surgery_notes_layout_option_${index}_${itemIndex}`}>{item?.layout_name}</MenuItem>
                        )) : <Typography align='center' emed_tid={`surgery_notes_layout_no_options_${index}`}>{t('NDF')}</Typography>}

                      </Select>
                    </FormControl>
                    <FormControl size='small' className='eMed_IP_Discharge_Select' emed_tid={`surgery_notes_template_form_${index}`}>
                      <InputLabel id="demo-simple-select-label" emed_tid={`surgery_notes_template_label_${index}`}>{`${t('SelectTemplate')} ${'(' + (states.surgeryTemplate.length > 0 ? states.surgeryTemplate.length : 0) + ')'}`}</InputLabel>
                      <Select
                        labelId="demo-simple-select-label"
                        id="demo-simple-select"
                        disabled={(addSurNotes[index].layout_id === '' || addSurNotes[index].layout_id === undefined) ? true : false}
                        value={addSurNotes[index].template_id}
                        readOnly={states.addSurNotes[index].is_finished === true || fromBillSummary ? true : false}
                        label={`${t('SelectTemplate')} ${'(' + (states.surgeryTemplate.length > 0 ? states.surgeryTemplate.length : 0) + ')'}`}
                        sx={{ backgroundColor: Colors.ThemeLightColor }}
                        onChange={(event) => { this.handleTemplate(event, index) }}
                        emed_tid={`surgery_notes_template_select_${index}`}
                      >
                        {states.surgeryTemplate?.length > 0 ? states.surgeryTemplate.map((item, itemIndex) => (
                          <MenuItem value={item.id} key={itemIndex} emed_tid={`surgery_notes_template_option_${index}_${itemIndex}`}>{item.template_name}</MenuItem>
                        )) : <Typography align='center' emed_tid={`surgery_notes_template_no_options_${index}`}>{t('NDF')}</Typography>}

                      </Select>
                    </FormControl>
                  </Box>
                </Box>
                {this.renderSNDesign(index)}
                <Box component={'div'} className='eMed_IP_Discharge_BtnGroup' emed_tid={`surgery_notes_accordion_buttons_${index}`}>
                  <Stack spacing={2} direction="row" emed_tid={`surgery_notes_button_stack_${index}`}>
                    <Button id='eMed_Config_btn' className='eMed_DisSum_Lay_select2' disabled={states.addSurNotes[index].is_finished === true || fromBillSummary || this.state.withOutAppointment?.is_ip ? true : false} variant='outlined' onClick={() => { this.ClearTemplateData(index) }} emed_tid={`surgery_notes_clear_btn_${index}`}>{t('Clear')}</Button>
                    <Button id='eMed_Config_btn' className='eMed_DisSum_Lay_select2' disabled={((CheckAccessFunc("front_office", "In Patients", "Therapy Notes", null, "Tab")?.editAccess)) ? (states.addSurNotes[index].layout_id === null || states.addSurNotes[index].layout_id === '' || states.addSurNotes[index].layout_id === undefined || states.addSurNotes[index].is_finished === true || fromBillSummary || this.state.withOutAppointment?.is_ip ? true : false || this.state.isSave) : true} variant='contained' onClick={() => { this.setState({ isSave: true }, () => { this.saveTemplate(false, index) }) }} emed_tid={`surgery_notes_save_btn_${index}`}>{t('Save')}</Button>
                    <Button id='eMed_Config_btn' className='eMed_DisSum_Lay_select2' disabled={((CheckAccessFunc("front_office", "In Patients", "Therapy Notes", null, "Tab")?.editAccess)) ? (states.addSurNotes[index].layout_id === null || states.addSurNotes[index].layout_id === '' || states.addSurNotes[index].layout_id === undefined || states.addSurNotes[index].is_finished === true || fromBillSummary || this.state.withOutAppointment?.is_ip ? true : false) : true} variant='contained' onClick={() => { this.saveTemplate(true, index) }} emed_tid={`surgery_notes_finish_btn_${index}`}>{t('Finish')}</Button>
                    <Button id='eMed_Config_btn' className='eMed_DisSum_Lay_select2' disabled={(states.addSurNotes[index].is_finished === true || fromBillSummary || this.state.withOutAppointment?.is_ip ? false : true) || this.state.isPrint} variant='contained' onClick={() => { this.setState({ isPrint: true }, () => { this.printSurNotes(list.id) }) }} emed_tid={`surgery_notes_print_btn_${index}`}>{t('Print')}</Button>
                  </Stack>
                </Box>
              </AccordionDetails>
            </Accordion>
          )
        }) : null}
        {(fromBillSummary || this.state.withOutAppointment?.is_ip) ? null :
          <Box className='eMed_SN_Add_Btn' emed_tid="surgery_notes_add_btn_container">
            <Button id='eMed_Config_btn' disabled={((CheckAccessFunc("front_office", "In Patients", "Therapy Notes", null, "Tab")?.editAccess)) ? (states.addSurNotes[New].is_finished === null ? true : false) : true} variant="contained" onClick={() => { this.addSurgeryNotes() }} emed_tid="surgery_notes_add_btn">{t('AT')}</Button>
          </Box>}
      </Box>
    )
  }
  addSurgeryNotes = () => {
    var states = this.state
    states['addSurNotes'].push({
      layout_id: '',
      template_id: '',
      template_data: {},
      date_time: null,
      name_of_doctor: '',
      signature: '',
      is_finished: null
    })
    this.setState({
      states
    })
  }
  saveTemplate = (isFinish, i) => {
    let states = this.state
    if (this.mantatoryFeilds(i)) {
      if (!states.addSurNotes[i]?.date_time && isFinish) {
        this.errorMessage(`Enter Date/Time`)
      } else {
        states.addSurNotes[i]['is_finished'] = isFinish
        this.setState({
          states
        })
        this.postSurgeryNotesTemplate(i)
      }
    }
  }
  mantatoryFeilds = (index) => {
    var states = this.state
    var data = states.surgeryLayout.filter((item) => (item.id == states?.addSurNotes[index]?.layout_id))
    var ManFeild = data[0].surgery_json

    let flag = false;
    for (let i = 0; i < ManFeild.length; i++) {
      if (ManFeild[i].is_mantatory === true) {
        if (ManFeild[i].field_name === "date_time_name_of_doctor_signature") {
          if (isNaN(Date.parse(states?.addSurNotes?.[index]?.date_time)) || !states?.addSurNotes?.[index]?.name_of_doctor || !states?.addSurNotes?.[index]?.signature) {
            flag = false
            if (isNaN(Date.parse(states?.addSurNotes?.[index]?.date_time))) {
              this.errorMessage(`Invalid DateTime`)
            } else {
              this.errorMessage(`${ManFeild[i].label} is Mantatory`)
            }
            this.setState({ isSave: false })
            break
          } else {
            flag = true
          }
        } else {
          if (states?.addSurNotes?.[index]?.['template_data']?.[ManFeild[i].field_name] === '') {
            flag = false
            this.errorMessage(`${ManFeild[i].label} is Mantatory`)
            this.setState({ isSave: false })
            break
          } else {
            flag = true
          }
        }
      }
    }
    return flag
  }
  ClearTemplateData = (i) => {
    var states = this.state
    var add_Notes = {
      spl_id: null,
      specTxt: '',
      layout_id: '',
      template_id: '',
      template_data: {},
      date_time: null,
      name_of_doctor: '',
      signature: '',
      is_finished: null,
    }
    var data = states.surgeryLayout.filter((item) => (item.id == states.addSurNotes[i].layout_id))
    var keys = {}
    data[0]?.surgery_json?.forEach((element) => {
      keys[element.field_name] = ''

    })
    states.addSurNotes[i].template_data = keys
    states.addSurNotes[i].date_time = null
    states.addSurNotes[i].name_of_doctor = ''
    states.addSurNotes[i].signature = ''
    this.setState({
      states,
      addSurgeryNotes: [add_Notes]
    })
    this.renderSNDesign(i)
  }

  handleLayout = (event, index) => {
    var { addSurNotes } = this.state
    addSurNotes[index]['layout_id'] = event.target.value
    addSurNotes[index]['template_id'] = ""
    this.setState({
      addSurNotes
    }, () => {
      this.getSurgeryTemplate(index)
      var states = this.state
      var data = states.surgeryLayout.filter((item) => (item.id == states.addSurNotes[index].layout_id))
      var keys = {}
      data[0]?.surgery_json?.forEach((element) => {
        keys[element.field_name] = ""
      })
      states.addSurNotes[index].template_data = keys
      this.setState({
        states
      })
    })
  }
  handleTemplate = (event, index) => {
    var { addSurNotes } = this.state
    addSurNotes[index]['template_id'] = event.target.value
    this.setState({
      addSurNotes
    }, () => {
      var states = this.state
      var tem_data = states?.surgeryTemplate?.map((item) => (
        item.template_data
      ))
      var data = states?.surgeryLayout?.filter((item) => (item.id == states.addSurNotes[index].layout_id))
      var keys = {}
      data[0]?.surgery_json?.forEach((element) => {
        if (tem_data.length > 0) {
          keys[element.field_name] = tem_data[0][element.field_name]
        }
      })
      states.addSurNotes[index]['template_data'] = keys
      this.setState({
        states,
      })
    })
  }


  renderSNDesign = (i) => {
    var states = this.state
    var datalabel = states.surgeryLayout.filter((item) => (item.id == states.addSurNotes[i].layout_id))
    return (
      <Box sx={{ height: '42vh', overflow: 'hidden auto' }} emed_tid={`surgery_notes_design_${i}`}>
        {datalabel.length === 1 ? datalabel[0].surgery_json.map((item, fieldIndex) => {
          if (item.label === "Date/Time, Name of Doctor, Signature" && item.is_active === true) {
            return (
              this.renderSNSignature(i, item?.is_mantatory)
            )
          } else {
            return (
              this.renderTextBoxs(item.label, '87vw', item.field_name, item.is_mantatory, true, i, item.is_active)
            )
          }
        }) : <Box className='eMed_SN_NoLayout' emed_tid={`surgery_notes_no_layout_${i}`}>
          <Typography color={'#888888'} emed_tid={`surgery_notes_no_layout_text_${i}`}>{'Please Select the Layout and Template'}</Typography>
        </Box>}
      </Box>
    )
  }
  renderSNSignature = (i, isMandatory = false) => {
    var states = this.state
    const { t, fromBillSummary } = this.props
    return (
      <Box className='eMed_SN_Sign_View' emed_tid={`surgery_notes_signature_${i}`}>
        <LocalizationProvider dateAdapter={AdapterDayjs} emed_tid={`surgery_notes_date_provider_${i}`}>
          <DateTimePicker
            value={states.addSurNotes[i].date_time}
            name={"datePicker"}
            inputFormat='DD-MM-YYYY hh:mm:ss a'
            label={`${t('Date/Time*')}${isMandatory ? "*" : ""}`}
            minDate={this.state.ipPatientData?.admission_date && new Date(this.state.ipPatientData?.admission_date)?.toISOString()?.split('T')[0]}
            readOnly={states.addSurNotes[i].is_finished === true || fromBillSummary ? true : false}
            onChange={
              (newDate) => {
                states.addSurNotes[i]['date_time'] = newDate
                this.setState({
                  states,
                });
              }}
            renderInput={(params) => <TextField style={{ width: '27vw' }} size='small' {...params} emed_tid={`surgery_notes_date_time_input_${i}`} />}
            emed_tid={`surgery_notes_date_time_picker_${i}`}
          />
        </LocalizationProvider>
        <TextField
          size='small'
          label={`${t('NameofDoctor')}${isMandatory ? "*" : ""}`}
          sx={{ width: '27vw' }}
          id="nameofdoctor"
          inputProps={{ readOnly: states.addSurNotes[i].is_finished === true || fromBillSummary ? true : false }}
          variant="outlined"
          value={states.addSurNotes[i].name_of_doctor}
          emed_tid={`surgery_notes_doctor_name_input_${i}`}
          onChange={(event) => {
            states.addSurNotes[i]['name_of_doctor'] = event.target.value
            this.setState({
              states
            })
          }}
        />
        <TextField
          size='small'
          label={`${t('Signature')}${isMandatory ? "*" : ""}`}
          sx={{ width: '27vw' }}
          id="signature"
          inputProps={{ readOnly: states.addSurNotes[i].is_finished === true || fromBillSummary ? true : false }}
          variant="outlined"
          value={states.addSurNotes[i].signature}
          emed_tid={`surgery_notes_signature_input_${i}`}
          onChange={(event) => {
            states.addSurNotes[i]['signature'] = event.target.value
            this.setState({
              states
            })
          }}
        />
      </Box>
    )
  }
  listenPopUp = () => {
    this.setState({
      listenPopUp: false
    })
  }
  voiceToTextgetter = (textStorage) => {
    if (textStorage != '') {
      let states = this.state
      let i = states.tempIndex
      let key = states.tempKey

      if (states.addSurNotes[i].template_data[key]?.length) {
        states.addSurNotes[i].template_data[key] = states.addSurNotes[i].template_data[key] + " " + textStorage
        this.setState({
          states
        })
      } else {
        states.addSurNotes[i].template_data[key] = textStorage
        this.setState({
          states
        })

      }
    }
    this.setState({
      listenPopUp: false
    })
  }
  renderTextBoxs = (label, width, key, mantatory, isrow, i, is_active) => {
    var states = this.state
    let { fromBillSummary } = this.props;
    if (is_active) {
      const fieldTid = key.replace(/([A-Z])/g, '_$1').toLowerCase();
      return (
        <Box className='eMed_DisSum_Lay_CommonBox1' emed_tid={`surgery_notes_field_box_${i}_${fieldTid}`}>
          <TextField
            sx={{ width: width }}
            id="icd-code"
            multiline={isrow}
            name={key}
            inputProps={{ readOnly: states.addSurNotes[i].is_finished === true || fromBillSummary ? true : false }}
            label={mantatory ? label + "*" : label}
            variant="outlined"
            value={states.addSurNotes[i].template_data[key] ? states.addSurNotes[i].template_data[key] : ''}
            emed_tid={`surgery_notes_field_input_${i}_${fieldTid}`}
            onChange={(event) => {
              states.addSurNotes[i].template_data[key] = event.target.value
              this.setState({
                states
              })
            }}
            InputProps={{
              endAdornment: <InputAdornment position="end" emed_tid={`surgery_notes_field_adornment_${i}_${fieldTid}`}>
                <MicIcon sx={{ color: grey[1000], cursor: "pointer" }} onClick={() => { this.setState({ listenPopUp: true, tempIndex: i, tempKey: key }) }} emed_tid={`surgery_notes_field_mic_icon_${i}_${fieldTid}`}></MicIcon>
              </InputAdornment>
            }}
          />
        </Box>
      )
    }
  }
  msgClose() {
    this.setState({
      isErrorMsg: false,
      isErrorMsgText: '',
      successMsg: false,
      successMsgText: ''
    })
  }
  render() {
    const { t, fromBillSummary } = this.props
    let attender = {
      lineOne: t("AttenderName"),
      lineTwo: `${this.state.attenderName ? this.state.attenderName : '-'}`,
      lineFour: t('ContactNumber'),
      LineFive: `${this.state.attenderMobile ? this.state.attenderMobile : '-'}`
    }
    let consultant = {
      lineOne: t("ConsultantName"),
      lineTwo: `${this.state.consultantName ? this.state.consultantName : '-'}`,
    }

    return (
      <Box component={'div'} className='eMed_patient_container' emed_tid="surgery_notes_container">
        <Box component={'div'} marginLeft={'0.5vw'} className='eMed_patient_header' sx={{ display: fromBillSummary ? "none" : "block" }} emed_tid="surgery_notes_header">
          <Box display={'flex'} alignItems='center' emed_tid="surgery_notes_header_content">
            <Box className='eMed_Patient_Details_Long eMed_patient_box' emed_tid="surgery_notes_patient_details">
              <CommonPatientDetails data={this.state.FromOT ? this.state.OTDetails : this.state.ipPatientData} showDetailed={true} emed_tid="surgery_notes_patient_details_component" />
            </Box>
            <CommonPatientCard details={attender} showDetailed={true} emed_tid="surgery_notes_attender_card" />
            <ConsultantPatientCard name={consultant} emed_tid="surgery_notes_consultant_card" />
          </Box>
        </Box>
        {this.renderAccordionView()}
        <Loader loaderOpen={this.state.isLoader} />
        {this.state.isErrorMsg ?
          <ToastMsg
            severity={'error'}
            msg={this.state.isErrorMsgText}
            msgPop={this.msgClose.bind(this)}
            emed_tid="surgery_notes_error_toast"
          />
          : null}
        {this.state.successMsg ?
          <ToastMsg
            severity={'success'}
            msg={this.state.successMsgText}
            msgPop={this.msgClose.bind(this)}
            emed_tid="surgery_notes_success_toast"
          />
          : null}
        {this.state.listenPopUp ?
          <VoiceToText
            voiceTextConverter={this.voiceToTextgetter.bind(this)}
            listenPopUp={this.listenPopUp.bind(this)}
            emed_tid="surgery_notes_voice_to_text_popup"
          />
          : null}
      </Box>
    )
  }
}
export default withTranslation()(TherapyNotes);